export const PAGE_SIZE_A4 = 'A4';
export const PAGE_SIZE_A3 = 'A3';
export const PAGE_SIZE_ARCH_D = 'ArchD';

export const PAGE_SIZE_DIMENSIONS = {
  [PAGE_SIZE_A4]: { width: 3508, height: 2480 },
  [PAGE_SIZE_A3]: { width: 4961, height: 3508 },
  [PAGE_SIZE_ARCH_D]: { width: 10800, height: 7200 },
};
